import { gsap, Power4 } from "gsap";

const heroSection1 = () => {
    const elements = {
        titleBigger: ".hero-section-1 .hero__title-bigger",
        text: ".hero-section-1 .hero__text",
        bg: ".hero-section-1 .hero__bg",
        btn: ".hero-section-1 .btn",
        logo: ".logo",
        menuItems: ".header__menu ul li",
        desktopBtn: ".header .btn--desktop"
    };

    new SplitText(`${elements.titleBigger}, ${elements.text}`, { type: "lines" });

    const loaderTimeline = gsap.timeline({ paused: true, defaults: { ease: Power4.easeInOut } });

    loaderTimeline
        .set(elements.titleBigger, { autoAlpha: 1 })
        .set(elements.text, { autoAlpha: 1 })
        .to(elements.bg, { duration: 2, autoAlpha: 1, filter: "blur(0px)" })
        .to(`${elements.titleBigger} > div`, { duration: 1.25, autoAlpha: 1, filter: "blur(0px)", y: 0, stagger: 0.1 }, "-=1.25")
        .to(`${elements.text} > div`, { duration: 1.25, autoAlpha: 1, filter: "blur(0px)", y: 0, stagger: 0.1 }, "-=1")
        .to(elements.btn, { duration: 0.65, autoAlpha: 1 }, "-=1.25")
        .to([elements.logo, elements.menuItems, elements.desktopBtn], { duration: 0.5, autoAlpha: 1, stagger: 0.1 }, "-=1.5");

    loaderTimeline.play();
};

export default heroSection1;